import { render, staticRenderFns } from "./LeadBoardDealPublic.vue?vue&type=template&id=434238aa&"
import script from "./LeadBoardDealPublic.vue?vue&type=script&lang=js&"
export * from "./LeadBoardDealPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports